/**
 * Session tariff in cents/kWh. Prefer the order-locked rate so a live SOC / time
 * dynamic price cannot change spent/sticker during charging.
 */
export function lockedCostPerKwtFromHistoryItem(item) {
  const priceCents = Number(item?.priceInCents);
  const periodKwt = Number(item?.periodKwt);
  if (!Number.isFinite(priceCents) || priceCents <= 0) {
    return null;
  }
  if (!Number.isFinite(periodKwt) || periodKwt <= 0 || periodKwt === 220) {
    return null;
  }
  return Math.trunc(priceCents / periodKwt);
}

function historyItemsList(historyData) {
  if (Array.isArray(historyData)) {
    return historyData;
  }
  if (Array.isArray(historyData?.items)) {
    return historyData.items;
  }
  return [];
}

export function lockedCostPerKwtFromHistory(historyData, lastJob, stationNumber) {
  const items = historyItemsList(historyData);
  if (!items.length) {
    return null;
  }
  const invoiceId = lastJob?.invoiceId;
  const jobId = lastJob?.id;
  const port = String(stationNumber ?? lastJob?.stationNumber ?? '');
  const match = items.find(item => {
    if (item?.state !== 'IN_PROGRESS') {
      return false;
    }
    if (jobId && item.chargingJobId && String(item.chargingJobId) === String(jobId)) {
      return true;
    }
    if (invoiceId && item.invoiceId && String(item.invoiceId) === String(invoiceId)) {
      return true;
    }
    return Boolean(port) && String(item.plugNumber) === port;
  });
  return lockedCostPerKwtFromHistoryItem(match);
}

export function resolveSessionCostPerKwt(lastJob, stationCostPerKwt, historyData, stationNumber) {
  const locked = Number(lastJob?.costPerKwt);
  if (Number.isFinite(locked) && locked > 0) {
    return locked;
  }
  const fromHistory = lockedCostPerKwtFromHistory(historyData, lastJob, stationNumber);
  if (fromHistory != null) {
    return fromHistory;
  }
  const live = Number(stationCostPerKwt);
  return Number.isFinite(live) ? live : stationCostPerKwt;
}
